<template>
  <footer>
    <p>All rights reserved @copyright Movie.lab.com</p>
  </footer>
</template>

<script>
export default {

}
</script>

<style>
footer{
  text-align: center;
  color: var(--secondary-text-color);
  padding: 20px 0;
  font-weight: normal;
}
</style>